import { ReportChartGroupItemMeasure } from '@vision/ui/interfaces';

export const BarChart5Measures: ReportChartGroupItemMeasure[] = [
  {
    type: 'feedback',
    items: [
      'feedback-count',
      'feedback-nps',
      'feedback-csat',
      'feedback-ces',
      'feedback-sentiment-score',
      'feedback-weighted-score',
      'feedback-chat-score',
    ],
  },
  {
    type: 'action-time',
    items: [
      'action-time-completion',
      'action-time-read',
      'action-time-response',
      'action-time-internal-note',
      'action-time-archived',
    ],
  },
  {
    type: 'response',
    items: ['response-count', 'response-ranking-overview'],
  },
  {
    type: 'customer',
    items: ['customer-count'],
  },
  {
    type: 'matrix-question',
    items: ['matrix-question-csat-overview'],
  },
];
